import React from 'react';
import { useParams } from 'react-router-dom';

import { SiteConfigManager, useTournamentState } from '@atlas/core';
import { SimpleEventSkeleton, SimpleFavouriteEventSkeleton } from '@atlas/ui';

const EventsLoader = ({ children }) => {
  const { tournamentName } = useParams();
  const { initialized, loading } = useTournamentState();

  const withFavorite = SiteConfigManager.getConfig(
    'config.config.sportsbook.enableFavouritesInSimplified',
  );

  if (!initialized && loading) {
    if (tournamentName && withFavorite) {
      return <SimpleFavouriteEventSkeleton />;
    }
    return <SimpleEventSkeleton outcomesNumber={1} />;
  }

  return children;
};

export default EventsLoader;
